import { useEffect, useState } from "react";
import axios from "axios";
import { ACCESS_KEY } from "../config";

function UserControl() {
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 20;

  useEffect(() => {
    getUsersList();
  }, []);

  // API Call: Get All Users
  const getUsersList = async () => {
    try {
      const response = await axios.get(
        "https://admin.butterlive.co.in/management/live-ban-users",
        { headers: { key: ACCESS_KEY } }
      );
      setUsers(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  // API Call: Reset Name
  const handleNameReset = async (user) => {
    const isConfirm = window.confirm(`Are you sure you want to reset name for ${user.uniqueId}?`);
    if (!isConfirm) return;

    try {
      const res = await axios.post(
        "https://admin.butterlive.co.in/management/reset-name",
        { userId: user.userId },
        { headers: { key: ACCESS_KEY } }
      );
      if (res.data.status) {
        alert("Name Reset Successfully!");
        getUsersList(); // Table refresh
      }
    } catch (error) {
      console.log(error);
      alert("Failed to reset name");
    }
  };

  // API Call: Toggle Name Block
  const handleNameBlockToggle = async (user) => {
    try {
      const newStatus = !user.isNameBlocked;
      const res = await axios.post(
        "https://admin.butterlive.co.in/management/toggle-name-ban",
        { userId: user.userId, isNameBlocked: newStatus },
        { headers: { key: ACCESS_KEY } }
      );
      if (res.data.status) {
        // UI ko bina refresh kiye update karna
        setUsers(users.map(u => u.userId === user.userId ? { ...u, isNameBlocked: newStatus } : u));
      }
    } catch (error) {
      console.log(error);
      alert("Failed to change name status");
    }
  };

  // API Call: Toggle Game Block
  const handleGameBlockToggle = async (user) => {
    try {
      const newStatus = !user.gameBlock;
      const res = await axios.post(
        "https://admin.butterlive.co.in/management/toggle-game-block",
        { userId: user.userId, gameBlock: newStatus },
        { headers: { key: ACCESS_KEY } }
      );
      if (res.data.status) {
        // UI ko bina refresh kiye update karna
        setUsers(users.map(u => u.userId === user.userId ? { ...u, gameBlock: newStatus } : u));
      }
    } catch (error) {
      console.log(error);
      alert("Failed to change game status");
    }
  };

  // --- Search & Pagination ---
  const filteredUsers = users.filter((user) =>
    (user.name || "").toLowerCase().includes(search.toLowerCase()) ||
    String(user.uniqueId || "").includes(search)
  );

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">User Control Management</h1>
      </div>

      <div className="top-bar">
        <input
          type="text"
          placeholder="Search Name / User ID"
          className="search-box"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="table-card">
        <table width="100%" cellPadding="12" style={{ minWidth: "1400px" }}>
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Photo</th>
              <th>Name</th>
              <th>User ID</th>
              <th>Name Status</th>
              <th>Name Actions</th>
              <th>Game Status</th>
              <th>Game Actions</th>
            </tr>
          </thead>

          <tbody>
            {currentUsers.map((user, index) => (
              <tr key={user.userId || index}>
                <td>{indexOfFirstUser + index + 1}</td>

                <td>
                  {user.image ? (
                    <img src={user.image} alt="Profile" className="user-avatar" />
                  ) : (
                    "—"
                  )}
                </td>

                <td>{user.name}</td>
                <td>{user.uniqueId}</td>

                {/* --- Name Status & Actions --- */}
                <td>
                  <span className={user.isNameBlocked ? "status-banned" : "status-active"}>
                    {user.isNameBlocked ? "Blocked" : "Active"}
                  </span>
                </td>
                <td>
                  <button
                    onClick={() => handleNameBlockToggle(user)}
                    className={user.isNameBlocked ? "ban-btn ban-btn-unban" : "ban-btn ban-btn-active"}
                    style={{ marginRight: "10px" }}
                  >
                    {user.isNameBlocked ? "Unblock Name" : "Block Name"}
                  </button>
                  <button
                    onClick={() => handleNameReset(user)}
                    className="ban-btn"
                    style={{ backgroundColor: "#6c757d", color: "white" }} 
                  >
                    Reset Name
                  </button>
                </td>

                {/* --- Game Status & Actions --- */}
                <td>
                  <span className={user.gameBlock ? "status-banned" : "status-active"}>
                    {user.gameBlock ? "Blocked" : "Active"}
                  </span>
                </td>
                <td>
                  <button
                    onClick={() => handleGameBlockToggle(user)}
                    className={user.gameBlock ? "ban-btn ban-btn-unban" : "ban-btn ban-btn-active"}
                  >
                    {user.gameBlock ? "Unblock Game" : "Block Game"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* --- Pagination --- */}
        <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserControl;
